import { motion } from 'framer-motion';

const familyImage = 'https://customer-assets.emergentagent.com/job_connect-premium-2/artifacts/554u2uis_family%204.jpg';

const FamilyWellness = () => {
  return (
    <section className="section section-warm" data-testid="family-wellness-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="family-image-section rounded-2xl overflow-hidden shadow-xl"
          >
            <img 
              src={familyImage}
              alt="Happy family dancing together"
              className="w-full h-[320px] md:h-[420px] object-cover"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#1A1A1A] mb-4">
              Family Wellness, Simplified.
            </h2>
            <p className="text-[#5A5A5A] text-base mb-5 leading-relaxed">
              Connect brings your family together through shared health insights, 
              location safety, and gentle daily check-ins.
            </p>
            <ul className="space-y-3">
              {[
                'One dashboard for the whole family',
                'See who is resting well and who needs support',
                'Location safety that respects privacy',
                'Works for kids, parents, and grandparents',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">✓</span>
                  <span className="text-[#4A4A4A] text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FamilyWellness;
